export enum CLIENT {
  LOCALHOST = "localhost",
  SANDBOX = "sandbox",
  WOM = "wom",
  CASAIDEAS = "casaideas",
  LOGYTECH = "logytech",
  SHIPERTO = "shiperto",
  PRIVILEGE = "privilege",
  SODIMAC = "sodimac",
  ENTEL_PERU = "entelperu",
  ENTEL = "entel",
}

export enum ENV {
  DEV = "dev",
  UAT = "uat",
  PROD = "prod",
}
